import {BATTERY_CHARGE_MAX} from '@dms/shared';

const BATTERY_CHARGE_DECIMALS = 2;

/**
 * @about Serializes a battery charge level for the API, which stores it as a 0–1 fraction
 * written with two decimals. The UI works in whole percent, so `85` becomes `'0.85'`.
 */
export function serializeBatteryCharge(value: number): string {
  return (value / BATTERY_CHARGE_MAX).toFixed(BATTERY_CHARGE_DECIMALS);
}
